module.exports = __webpack_public_path__ + "media/icons/offer-details-budowlane@3x-817f25dc.svg";